import { useEffect, useState} from 'react';
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { navigationPropertiesTypes, useNavigation } from "./routes/Navigation";
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import AuthLayout from './layout/auth/AuthLayout';
import DashboardLayout from './layout/Dashboard/DashboardLayout';
import { pageData } from './metadescriptions';
import MeetLayout from './layout/Meet/MeetLayout';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, lightTheme } from 'amazon-chime-sdk-component-library-react';
import { initDatabase } from './database';
import { isPlatform } from '@ionic/react';
import { getAppVersion } from './utils/helper';
import { useQuery } from '@apollo/client';
import { GET_VERSION } from './pages/Help/api/Help';
import ConfirmationPopup from './components/ConfirmationPopup/ConfirmationPopup';
import images from './assets/images';
import { useDispatch } from 'react-redux';
import { useAppSelector } from './redux/app/hooks';
import { setLoginUser } from './redux/slices/authSlice';
import { CommonEvents, PageViewEvents, RouteNames } from './firebase/constants/events';
import { trackPageView } from './firebase/analyticsHelper';
import { FETCH_POLICY, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from './utils/constants';
import { KatonMeetProvider } from './components/KatonMeet/KatonMeetContext';
import KatonMeetHost from './components/KatonMeet/KatonMeetHost';
import { useStudentPushNotifications } from './firebase/useStudentPushNotifications';

function App() {
  
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isForceUpdate, setIsForceUpdate] = useState(false);
  const [updateUrl, setUpdateUrl] = useState('');
  const location = useLocation();
  const pathname = location.pathname;
  const {navigation} = useNavigation();
  const { logoutGif } = images;
  const navigate = useNavigate();
  const { role, loginpage } = useAppSelector((state) => state?.auth);
  // Get the Token from the Redux
  const accessToken = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('accessToken')) as string) || '';

  // Web push for students and teachers (e.g. new live class scheduled), only while one of them is logged in
  const currentUserId = useAppSelector((state) => state?.auth?.adminProfile?.getCurrentUser?.nodes?.[0]?.uId);
  const isPushUserLoggedIn = Boolean(accessToken) && (role === STUDENT_ROLE || role === TEACHER_ROLE);
  useStudentPushNotifications({
    // Register and show notifications only while a student or teacher is logged in; logout removes the FID and unregisters
    enabled: isPushUserLoggedIn,
    displayEnabled: isPushUserLoggedIn,
    userId: currentUserId,
  });
  const dispatch = useDispatch();
  const isKaton = useAppSelector((state) => state.auth.isKaton);

  useEffect(() => {
    if (accessToken) {
      localStorage.removeItem("vs_temp_tokens");
    }
  }, [accessToken]);

  const { data: version } = useQuery(GET_VERSION, {
    variables: { platformtype: isPlatform('android') ? 'ANDROID' : 'EXE'},
    fetchPolicy: FETCH_POLICY,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    document.addEventListener('deviceready', onDeviceReady, false);
    return () => {
      document.removeEventListener('deviceready', onDeviceReady, false);
    };
  }, [version]);

  const compareVersions = (v1: string|null, v2: string) => {
    const v1Parts = v1 ? v1?.split('.').map(Number) : [];
    const v2Parts = v2?.split('.').map(Number);
    const length = Math.max(v1Parts.length, v2Parts.length);
    for (let i = 0; i < length; i++) {
      const a = v1Parts[i] || 0;
      const b = v2Parts[i] || 0;
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
    }
    return 0;
  };

  const onDeviceReady = async () => {
    try {
      const currentVersion = await getAppVersion();

      const latestVersion = version?.allVersions?.nodes[0]?.appVersion;
      const isForceUpdateFlag = version?.allVersions?.nodes[0]?.isForceUpdate;
      const playStoreUrl = 'https://install.appcenter.ms/orgs/360classroom-android-native/apps/360classroom/releases/9?source=email#x3D;email&tid=dDzfCsdcgKk';

      console.log(currentVersion,'======currentVersion');
      
      console.log(latestVersion,isForceUpdateFlag,'======latest version');
      

      if (compareVersions(currentVersion, latestVersion) < 0) {
        console.log('the app is in force update');
        setIsForceUpdate(isForceUpdateFlag);
        setUpdateUrl(playStoreUrl);
        setShowUpdateModal(true);
      }
    } catch (error) {
      console.error('Version check failed:', error);
    }
  };

  useEffect(() => {
    const pageInfo = pageData[pathname];
    if (pageInfo) {
        document.title = `Katon360 Classroom - ${pageInfo.title}`;

        const metaDescriptionTag = document.querySelector('head > meta[name="description"]');
        if (metaDescriptionTag) {
            metaDescriptionTag.setAttribute("content", pageInfo.metaDescription);
        }
    }
}, [pathname]);

  useEffect(() => {

    const params = new URLSearchParams(location?.search);
    const loginAs: any = params.get('loginAs');
    console.log("[Log]", { document, isKaton, params, loginAs });
    if (loginAs) {
      dispatch(setLoginUser({ loginAs }));
    }
    if(isPlatform('android')){
      initDatabase()
      .then(() => {
          console.log('Database initialized');
      })
      .catch((error) => {
          console.error('Database initialization failed', error);
      });
    }

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const metaViewport = document.querySelector('meta[name="viewport"]');

    if (isIOS && metaViewport) {
      metaViewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1'
      );
    }

  }, []);

  const handleUpdate = () => {
    if (window?.cordova && window?.cordova?.InAppBrowser) {
      window?.cordova?.InAppBrowser.open(updateUrl, '_system');
    } else {
      window.open(updateUrl, '_blank');
    }
  };

  const handleSkip = () => {
    setShowUpdateModal(false);
  };

  console.log(showUpdateModal,'====showUpdateModal')
 useEffect(() => {
  const path = location.pathname;
  const eventName = PageViewEvents[path] || CommonEvents.PAGE_VIEW;
  const screenName = RouteNames[path] || path;
  trackPageView(eventName, screenName, {
    description: `User entered into the ${screenName}`,
  });
}, [location]);

    const navigatePaths = (meetingState:any) => {
      console.log("[Logging] navigatePaths called with meetingState:", meetingState);
    console.log("[log] role", role, meetingState?.meetComponent);
        localStorage.setItem("isJoined", "left");
      if (role && meetingState?.meetComponent) {
        if (role === STUDENT_ROLE) {
          navigate("/student-classroom/liveclass", { state: meetingState });
        } else if (role === TEACHER_ROLE && meetingState?.meetComponent === "liveclass") {
          navigate("/teacher-classroom/liveclass", { state: meetingState });
        } else if (role === TEACHER_ROLE && meetingState?.meetComponent === "workshop") {
          navigate("/teacher-workshop");
        } else if (role === TEACHER_ROLE && meetingState?.meetComponent === "pta") {
          navigate("/teacher-pta", {
            state: meetingState,
          });
        } else if (role === SCHOOL_ADMIN && meetingState?.meetComponent === "pta") {
          navigate("/admin-pta/meetings", {
            state: meetingState,
          });
        } else if (role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN && meetingState?.meetComponent === "workshop") {
          navigate("/admin-workshop");
        } else if (role === PTA_ROLE) {
          navigate("/pta-meetings", {
            state: meetingState,
          });
        }
      }
    };

useEffect(() => {
  if (window?.electron && window?.electron?.isElectron()) {
    window?.electron.onMeetingEnd((_event, state) => {
      console.log("[Logging] Meeting ended event received in App.tsx:", state);
      navigatePaths(state);  //  auto return based on role
    });
  }
}, []);

  return (
    <KatonMeetProvider isSignedIn={Boolean(accessToken)}>
      <Routes>
        <Route path="*" element={<Navigate to='/'/>}/>
        {/* Public Routes */}
        {
          navigation?.public?.map((route: navigationPropertiesTypes)=>(
            <Route 
              path={route.path}
              key={route.path}
              element={
                <PublicRoute>
                  <AuthLayout component={route.component}/>
                </PublicRoute>
              }
            />
          ))
        }
        {/* Private Routes access only after SignIn */}
        { accessToken &&
            navigation?.private?.map((route: navigationPropertiesTypes)=>(
            <Route
            path={route.path}
            key={route.path}
            element={
              <PrivateRoute>
                <DashboardLayout component={route.component}/>
              </PrivateRoute>
            }
            />
          ))
        }
        { accessToken &&
            navigation?.meet?.map((route: navigationPropertiesTypes)=>(
            <Route
            path={route.path}
            key={route.path}
            element={
              <PrivateRoute>
                <ThemeProvider theme={lightTheme}>
                <GlobalStyles />
                <MeetLayout component={route.component}/>
                </ThemeProvider>
              </PrivateRoute>
            }
            />
          ))
        }
      </Routes>
      {/* Katon Meet iframe lives outside <Routes> so the meeting (and its PiP) stays alive on every page */}
      {accessToken && <KatonMeetHost />}
      {showUpdateModal && (
        <ConfirmationPopup
          open={showUpdateModal}
          page={`AppUpdate`}
          isForceUpdate={isForceUpdate}
          message={isForceUpdate ? 'A new version of the app is available. Please update to continue.' : 'A new version of the app is available. Would you like to update?'}
          gifData={logoutGif}
          yesButtonFunctionality={handleUpdate}
          noButtonFunctionality={!isForceUpdate ? handleSkip : () => {}}
          messageWidth={'300px'}
        />
      )}
    </KatonMeetProvider>
  );
}

export default App;
